import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/android': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M89.6 204.5V320.3C89.6 335.7 77.5 348 62.1 348 46.8 348 32 335.6 32 320.3V204.5C32 189.4 46.8 177 62.1 177 77.2 177 89.6 189.4 89.6 204.5zM100.4 361.5C100.4 377.9 113.6 391.1 130 391.1H149.9L150.2 452.2C150.2 489.1 205.4 488.8 205.4 452.2V391.1H242.6V452.2C242.6 488.9 298.1 489 298.1 452.2V391.1H318.3C334.5 391.1 347.7 377.9 347.7 361.5V182.1H100.4V361.5zM348.4 172.4H99.3C99.3 129.6 124.9 92.4 162.9 73L143.8 37.7C141 32.8 148.1 29.7 150.5 33.9L169.9 69.5C204.8 54 244.9 54.8 278.2 69.5L297.5 34C300 29.7 307 32.9 304.2 37.8L285.1 73C322.8 92.4 348.4 129.6 348.4 172.4zM177.7 116.9C177.7 111.2 173.1 106.4 167.2 106.4 161.5 106.4 157 111.2 157 116.9S161.6 127.4 167.2 127.4C173.1 127.4 177.7 122.6 177.7 116.9zM291.1 116.9C291.1 111.2 286.5 106.4 280.9 106.4 275 106.4 270.4 111.2 270.4 116.9S275 127.4 280.9 127.4C286.5 127.4 291.1 122.6 291.1 116.9zM385.9 177C370.8 177 358.4 189.1 358.4 204.5V320.3C358.4 335.7 370.8 348 385.9 348 401.3 348 416 335.6 416 320.3V204.5C416 189.1 401.2 177 385.9 177z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/android.js
// module id = X9Ui
// module chunks = 144